'use client';

export default function GlobalError({ error }: { error: Error }) {
  return (
    <div style={{ padding: '2rem', color: 'red' }}>
      <h1>Something went wrong</h1>
      <p>{error.message}</p>
    </div>
  );
}
